<template>
  <div class="container-xl g-0 g-lg-2">
    <div class="row h-100 g-0 g-lg-2">
      <div class="col h-100">
        <div class="header-small d-flex row" :style="{ backgroundImage: `url(${this.headerbg}) !important` }">
          <div class="col-11 col-xl-5 col-lg-6 h-100 d-lg-flex ">
            <div class="promo-form ic-form header-form itinerary-form mt-auto py-5 flex-grow-1 pb-0 pb-lg-5">
              <form class="form-medium jsFormHelpersConnections-Contener jsStationAlerts" name="searchTrain" method="get">
                <h1 class="h3">
                  Łowcy <strong>Super Promo!</strong>
                </h1>
                <div class="typehead-container">
                  <slot name="lowcy-from">
                    <div role="combobox" aria-haspopup="listbox"  aria-expanded="false" class="start mb-3 no-border">
                        <div class="input-group"> 
                            <input type="search" id="stname-0" name="stname[0]" :value="stname0" aria-label="Stacja odjazdu. Rozpocznij wpisywanie a po trzech wprowadzonych znakach wyniki wyszukiwania pojawią się automatycznie. Aby przejść na wyniki wyszukiwania naciśnij strzałkę w dół" class="jsStationTypeaheadItem jsCzwartkomaniaNearestStationItem form-control"  placeholder="np. Warszawa Centralna" autocomplete="off"  role="searchbox" aria-multiline="false" aria-autocomplete="list" data-params='{ "from":1 ,"czwartkomania":1 }' />
                            <input type="hidden" name="stid[0]" :value="stid0" class="jsTypeaheadItem-Value" />
                            <p class="input-group-append">
                                  SKĄD
                            </p>
                        </div> 
                       
                    </div>
                  </slot>
<!-- 

                  <vue-typeahead-bootstrap
                      v-model="query1"
                      :data="['Warszawa','Gdańsk', 'Wałbrzych', 'Wąchock', 'Warka', 'Wałcz']"
                      placeholder="Wybierz miejscowość"
                      class="start mb-3 no-border"
                      :showOnFocus="true"
                  >
                    <template slot="append">
                      SKĄD
                    </template>
                    <template slot="suggestion" slot-scope="{ data, htmlText }">
                      <div class="d-flex align-items-center">
                        <img
                            class="ms-1"
                            src="/images/pin-blue.svg"
                            style="width: 20px; height: 20px;"/>

                        <span class="ms-2" v-html="htmlText"></span>
                      </div>
                    </template>
                  </vue-typeahead-bootstrap> -->
                  <a href="#" @click.prevent="reverse" class="switch d-flex h-100 align-items-center d-none"><i
                      class="bi bi-arrow-down-up"></i></a>
                </div>
                  <slot name="lowcy-to">
                    <div role="combobox" aria-haspopup="listbox"  aria-expanded="false" class="end no-border">
                        <div class="input-group"> 
                            <input type="search" id="stname-1" name="stname[1]" :value="stname1" aria-label="Stacja przyjazdu. Rozpocznij wpisywanie a po trzech wprowadzonych znakach wyniki wyszukiwania pojawią się automatycznie. Aby przejść na wyniki wyszukiwania naciśnij strzałkę w dół" class="jsStationTypeaheadItem  form-control"  placeholder="np. Szczecin Główny" autocomplete="off"  role="searchbox" aria-multiline="false" aria-autocomplete="list" data-params='{ "to":1 ,"czwartkomania":1 }'/>
                            <input type="hidden" name="stid[1]" :value="stid1" class="jsTypeaheadItem-Value" />
                            <p class="input-group-append">
                                  DOKĄD
                            </p>
                        </div> 
                       
                    </div>
                  </slot>                                  
<!--                 <vue-typeahead-bootstrap
                    v-model="query2"
                    :data="['Warszawa','Gdańsk', 'Wałbrzych', 'Wąchock', 'Warka', 'Wałcz']"
                    placeholder="Wybierz miejscowość"
                    class="end no-border"
                    :showOnFocus="true"
                >
                  <template slot="append">
                    DOKĄD
                  </template>
                  <template slot="suggestion" slot-scope="{ data, htmlText }">
                    <div class="d-flex align-items-center">
                      <img
                          class="ms-1"
                          src="/images/pin-blue.svg"
                          style="width: 20px; height: 20px;"/>
                      <span class="ms-2" v-html="htmlText"></span>
                    </div>
                  </template>
                </vue-typeahead-bootstrap> -->
                <button type="submit" class="btn btn-warning mt-3">Szukaj</button>
                <input type='hidden' id='date' name='date' :value="date"/>
                <input type="hidden" name="hafasPage" value="0" class="jsVariable-HafasPage" />
                <input type="hidden" name="hafasSort" value="" class="jsVariable-HafasSort" />
                <input type="hidden" name="search" value="1" class="jsVariable-HafasSort" />                
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

export default {
  name: 'section-header-small-form',
  props: {
    headerbg: {type: String, default: '/images/temp/header-small-bg.png'},
    stid1: String,
    stid0: String,
    stname0: String,
    stname1: String, 
    date: String

  },
  components: {
    VueTypeaheadBootstrap
  },
  data() {
    return {
      query1: 'Warszawa',
      query2: 'Wąchock',

    }
  },
  computed: {
  },
  methods: {
    reverse() {
      let temp = this.stid1;
      this.stid1 = this.stid0;
      this.stid0 = temp;
    }
  }
}
</script>